import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import Checkbox from "@cloudscape-design/components/checkbox";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Grid from "@cloudscape-design/components/grid";
import DatePicker from "@cloudscape-design/components/date-picker";
import Toggle from "@cloudscape-design/components/toggle";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { bannersAddModalStore, BannersAddModalStore, ALLOWED_EXTERNAL_HOSTS, MAX_BANNER_BYTES, normalizeRequireAuthValue } from "../stores/bannersAddModal";
import { bannersStore, BannersStore } from "../stores/banners";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";

const getTodayRange = () => {
	const start = new Date();
	start.setHours(0, 0, 0, 0);
	const end = new Date();
	end.setHours(23, 59, 59, 999);

	return {
		startDate: start.toISOString(),
		endDate: end.toISOString(),
	};
};

const isAllowedExternalBannerLink = (rawValue) => {
	try {
		return ALLOWED_EXTERNAL_HOSTS.includes(rawValue);
	} catch (error) {
		return false;
	}
};

const isValidBannerFileSize = (file) => Boolean(file) && file.size <= MAX_BANNER_BYTES;

class BannersAddModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};
	}
	componentDidUpdate(prevProps) {
		if (!prevProps.bannersAddModal.show && this.props.bannersAddModal.show) {
			this.resetFormFields();
			if (normalizeRequireAuthValue(this.props.bannersAddModal.requireAuth) !== this.props.bannersAddModal.requireAuth) {
				this.updateParam("requireAuth", normalizeRequireAuthValue(this.props.bannersAddModal.requireAuth));
			}
		}
	}

	addBanner() {
		if (this.props.bannersAddModal.linkType?.value === "external" && !isAllowedExternalBannerLink(this.props.bannersAddModal.link)) {
			this.props.Interface.addNoty("Error", "External links are allowed only for vk or tg");

			return;
		}

		this.setState({
			loading: true,
		});
		const { requireTg, requireEmail, ...bannerPayload } = this.props.bannersAddModal;
		const payload = {
			...bannerPayload,
			skipLinkTg: requireTg ? 1 : 0,
			skipLinkEmail: requireEmail ? 1 : 0,
		};
		this.props.Interface.request(
			"set",
			{
				class: "data",
				module: "banners",
				method: "add",
			},
			payload,
		)
			.then((result) => {
				this.setState({
					loading: false,
				});
				this.props.Interface.addNoty("Success", "Banner was successfully added");
				this.props.setBannersAddModal({ ...this.props.bannersAddModal, show: false });
				this.props.Interface.loadBannerList();
			})
			.catch((error) => {
				if (typeof error.text === "undefined") error = { text: error.toString() };
				this.props.setBanners({ ...this.props.banners, loaded: true, error });

				this.setState({
					loading: false,
				});
			});
	}

	resetFormFields = () => {
		this.props.setBannersAddModal({
			...this.props.bannersAddModal,
			buttonText: "",
			link: "",
			title: "",
			badge: "",
			personalization: false,
			description: "",
			descriptionType: "",
			descriptionDefault: "",
			descriptionDefaultType: "",
			analyticsID: "",
			requireAuth: "0",
			requireTg: false,
			requireEmail: false,
			active: { value: "0", label: "0" },
			order: "",
			from: "",
			to: "",
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateParam = (key, value) => {
		const updatedState = cloneDeep(this.props.bannersAddModal);
		updatedState[key] = value;
		this.props.setBannersAddModal(updatedState);
	};

	render() {
		const { bannersAddModal, setBannersAddModal } = this.props;
		return (
			<Modal
				visible={bannersAddModal.show}
				onDismiss={() => setBannersAddModal({ ...bannersAddModal, show: false })}
				header="Add Banner"
				children={
					<SpaceBetween direction="vertical" size="m">
						<Box variant="span">Title Type</Box>
						<Select filteringType="auto" placeholder="Select title type" selectedOption={bannersAddModal.titleType} onChange={(option) => this.updateParam("titleType", option.detail.selectedOption)} options={bannersAddModal.currentOption.titleType} />
						<Box variant="span">Title</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Title"
							value={bannersAddModal.title}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									title: event.detail.value,
								})
							}
						/>
						<Box variant="span">Image</Box>
						<input
							type="file"
							accept="image/png"
							onChange={(event) => {
								const file = event.target.files[0];
								if (file) {
									if (!isValidBannerFileSize(file)) {
										this.props.Interface.addNoty("Error", `Image size must not exceed ${MAX_BANNER_BYTES / 1024 / 1024} MB`);
										event.target.value = "";

										return;
									}

									const reader = new FileReader();
									reader.onload = (event) => {
										const result = event.target.result;
										this.updateParam("image", result);
									};
									reader.readAsDataURL(file);
								} else {
									this.props.Interface.addNoty("Error", "Please, select a valid image file");
								}
							}}
						/>
						<Box variant="span">Button Text Type</Box>
						<Select filteringType="auto" placeholder="Select button type" selectedOption={bannersAddModal.buttonTextType} onChange={(option) => this.updateParam("buttonTextType", option.detail.selectedOption)} options={bannersAddModal.currentOption.buttonTextType} />
						<Box variant="span">Button Type</Box>
						<Select filteringType="auto" placeholder="Select button type" selectedOption={bannersAddModal.buttonType} onChange={(option) => this.updateParam("buttonType", option.detail.selectedOption)} options={bannersAddModal.currentOption.buttonType} />
						<Box variant="span">Button Text</Box>
						<Input
							name="ButtonText"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Button Text"
							value={bannersAddModal.buttonText}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									buttonText: event.detail.value,
								})
							}
						/>
						<Box variant="span">Link Type</Box>
						<Select filteringType="auto" placeholder="Select link type" selectedOption={bannersAddModal.linkType} onChange={(option) => this.updateParam("linkType", option.detail.selectedOption)} options={bannersAddModal.currentOption.linkType} />
						<Box variant="span">Link</Box>
						<Input
							name="Link"
							autoComplete="off"
							inputMode="url"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Link"
							value={bannersAddModal.link}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									link: event.detail.value,
								})
							}
						/>
						<Box variant="span">Description Type</Box>
						<Select filteringType="auto" placeholder="Select description type" selectedOption={bannersAddModal.descriptionType} onChange={(option) => this.updateParam("descriptionType", option.detail.selectedOption)} options={bannersAddModal.currentOption.descriptionType} />
						<Grid disableGutters gridDefinition={[{ colspan: 9 }, { colspan: 3 }]}>
							<Box variant="span" margin={{ right: "xxxs" }}>
								Description
							</Box>
							<SpaceBetween direction="horizontal">
								<Box margin={{ right: "xs" }}>Personalization</Box>
								<Checkbox
									checked={bannersAddModal.personalization}
									onChange={({ detail }) => {
										setBannersAddModal({
											...bannersAddModal,
											personalization: detail.checked,
										});
									}}
								/>
							</SpaceBetween>
						</Grid>

						<Input
							name="Description"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder={bannersAddModal.personalization ? "Description with user name key {userName}" : "Description"}
							value={bannersAddModal.description}
							onChange={(event) => {
								setBannersAddModal({
									...bannersAddModal,
									description: event.detail.value,
								});
							}}
						/>

						{bannersAddModal.personalization && (
							<>
								<Box variant="span">Default Description Type</Box>
								<Select filteringType="auto" placeholder="Select default description type" selectedOption={bannersAddModal.descriptionDefaultType} onChange={(option) => this.updateParam("descriptionDefaultType", option.detail.selectedOption)} options={bannersAddModal.currentOption.descriptionDefaultType} />

								<Box variant="span">Default Description</Box>
								<Input
									name="descriptionDefault"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Default Description"
									value={bannersAddModal.descriptionDefault}
									onChange={(event) => {
										setBannersAddModal({
											...bannersAddModal,
											descriptionDefault: event.detail.value,
										});
									}}
								/>
							</>
						)}

						<Box variant="span">Badge Type</Box>
						<Select filteringType="auto" placeholder="Select badge type" selectedOption={bannersAddModal.badgeType} onChange={(option) => this.updateParam("badgeType", option.detail.selectedOption)} options={bannersAddModal.currentOption.badgeType} />
						<Box variant="span">Badge</Box>
						<Input
							name="Badge"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Badge"
							value={bannersAddModal.badge}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									badge: event.detail.value,
								})
							}
						/>
						<Box variant="span">Analytics ID</Box>
						<Input
							name="AnalyticsID"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Analytics ID"
							value={bannersAddModal.analyticsID}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									analyticsID: event.detail.value,
								})
							}
						/>
						<SpaceBetween direction="horizontal" size="l">
							<Toggle
								checked={String(bannersAddModal.active?.value ?? bannersAddModal.active) === "1"}
								onChange={({ detail }) =>
									this.updateParam("active", {
										value: detail.checked ? "1" : "0",
										label: detail.checked ? "1" : "0",
									})
								}>
								{String(bannersAddModal.active?.value ?? bannersAddModal.active) === "1" ? "Active" : "Inactive"}
							</Toggle>
							<Toggle checked={normalizeRequireAuthValue(bannersAddModal.requireAuth) === "1"} onChange={({ detail }) => this.updateParam("requireAuth", detail.checked ? "1" : "0")}>
								{normalizeRequireAuthValue(bannersAddModal.requireAuth) === "1" ? "Required" : "Not required"}
							</Toggle>
						</SpaceBetween>
						<SpaceBetween direction="horizontal" size="l">
							<Checkbox checked={bannersAddModal.requireTg} onChange={({ detail }) => this.updateParam("requireTg", detail.checked)}>
								Skip link TG
							</Checkbox>
							<Checkbox checked={bannersAddModal.requireEmail} onChange={({ detail }) => this.updateParam("requireEmail", detail.checked)}>
								Skip link Email
							</Checkbox>
						</SpaceBetween>
						<Box variant="span">Order</Box>
						<Input
							name="Order"
							autoComplete="off"
							inputMode="number"
							type="number"
							disableBrowserAutocorrect={true}
							placeholder="Order"
							value={bannersAddModal.order}
							onChange={(event) =>
								setBannersAddModal({
									...bannersAddModal,
									order: event.detail.value,
								})
							}
						/>
						<Box variant="span">From/to</Box>
						<DateRangePicker
							onChange={({ detail }) => {
								setBannersAddModal({
									...bannersAddModal,
									from: detail.value.startDate.split("+")[0],
									to: detail.value.endDate.split("+")[0],
									type: detail.value.type,
								});
							}}
							value={{
								startDate: bannersAddModal.from,
								endDate: bannersAddModal.to,
								type: "absolute",
							}}
							relativeOptions={[]}
							isValidRange={(range) => {
								if (range.type === "absolute") {
									const [startDateWithoutTime] = range.startDate.split("T");
									const [endDateWithoutTime] = range.endDate.split("T");
									if (!startDateWithoutTime || !endDateWithoutTime) {
										return {
											valid: false,
											errorMessage: "The selected date range is incomplete. Select a start and end date for the date range.",
										};
									}
									if (new Date(range.startDate) - new Date(range.endDate) > 0) {
										return {
											valid: false,
											errorMessage: "The selected date range is invalid. The start date must be before the end date.",
										};
									}
								} else {
									return { valid: false };
								}
							}}
							i18nStrings={{
								todayAriaLabel: "Today",
								nextMonthAriaLabel: "Next month",
								previousMonthAriaLabel: "Previous month",
								customRelativeRangeDurationLabel: "Duration",
								customRelativeRangeDurationPlaceholder: "Enter duration",
								customRelativeRangeOptionLabel: "Custom range",
								customRelativeRangeOptionDescription: "Define a custom range in the past",
								customRelativeRangeUnitLabel: "Unit of time",
								formatRelativeRange: ({ amount, unit, startDate, endDate }) => {
									const start = new Date(startDate);
									const end = new Date(endDate);

									const locale = "en-GB";
									const dateOptions = { year: "numeric", month: "long", day: "numeric" };
									const timeOptions = { hour: "2-digit", minute: "2-digit", second: "2-digit" };

									const formattedStart = start.toLocaleDateString(locale, dateOptions) + " " + start.toLocaleTimeString(locale, timeOptions);
									const formattedEnd = end.toLocaleDateString(locale, dateOptions) + " " + end.toLocaleTimeString(locale, timeOptions);

									return `${formattedStart} - ${formattedEnd}`;
								},
								formatUnit: (unit, amount) => `${unit}${amount > 1 ? "s" : ""}`,
								dateTimeConstraintText: "Date and time must be within the selected range.",
								renderSelectedAbsoluteRangeAriaLive: (startDate, endDate) => `Selected from ${startDate} to ${endDate}`,
								labelRelativeRange: "Relative range",
								labelAbsoluteRange: "Absolute range",
								dateTimePickerAriaLabel: "Date and time picker",
								dateTimePickerLabel: "Date and Time",
								clearButtonAriaLabel: "Clear date range",
								relativeModeTitle: "Relative mode",
								absoluteModeTitle: "Absolute mode",
								cancelButtonLabel: "Cancel",
								applyButtonLabel: "Apply",
							}}
							placeholder="From/to"
						/>
					</SpaceBetween>
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button variant="normal" onClick={() => setBannersAddModal({ ...bannersAddModal, show: false })} children="Close" />
							<Button variant="primary" disabled={this.state.loading} onClick={() => this.addBanner()} children="Ok" />
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const bannersAddModal = useRecoilValue(bannersAddModalStore);
		const setBannersAddModal = useSetRecoilState(bannersAddModalStore);
		const banners = useRecoilValue(bannersStore);
		const setBanners = useSetRecoilState(bannersStore);
		return <Component {...props} banners={banners} setBanners={setBanners} setBannersAddModal={setBannersAddModal} bannersAddModal={bannersAddModal} />;
	};
}

export default withRecoil(BannersAddModal);
